export * from './agent.client';
import { AgentClient } from './agent.client';
export * from './agent-status.client';
import { AgentStatusClient } from './agent-status.client';
export * from './audit.client';
import { AuditClient } from './audit.client';
export * from './client-dictionary.client';
import { ClientDictionaryClient } from './client-dictionary.client';
export * from './coin.client';
import { CoinClient } from './coin.client';
export * from './container.client';
import { ContainerClient } from './container.client';
export * from './container-dictionary.client';
import { ContainerDictionaryClient } from './container-dictionary.client';
export * from './dashboard.client';
import { DashboardClient } from './dashboard.client';
export * from './equipment.client';
import { EquipmentClient } from './equipment.client';
export * from './equipment-event-category.client';
import { EquipmentEventCategoryClient } from './equipment-event-category.client';
export * from './equipment-event-history.client';
import { EquipmentEventHistoryClient } from './equipment-event-history.client';
export * from './equipment-identifier.client';
import { EquipmentIdentifierClient } from './equipment-identifier.client';
export * from './equipment-mode.client';
import { EquipmentModeClient } from './equipment-mode.client';
export * from './equipment-model.client';
import { EquipmentModelClient } from './equipment-model.client';
export * from './equipment-model-dictionary.client';
import { EquipmentModelDictionaryClient } from './equipment-model-dictionary.client';
export * from './equipment-schedule.client';
import { EquipmentScheduleClient } from './equipment-schedule.client';
export * from './equipment-schedule-assignment.client';
import { EquipmentScheduleAssignmentClient } from './equipment-schedule-assignment.client';
export * from './equipment-status.client';
import { EquipmentStatusClient } from './equipment-status.client';
export * from './facility.client';
import { FacilityClient } from './facility.client';
export * from './facility-dictionary.client';
import { FacilityDictionaryClient } from './facility-dictionary.client';
export * from './firmware.client';
import { FirmwareClient } from './firmware.client';
export * from './hashrate-unit.client';
import { HashrateUnitClient } from './hashrate-unit.client';
export * from './maintenance.client';
import { MaintenanceClient } from './maintenance.client';
export * from './maintenance-error.client';
import { MaintenanceErrorClient } from './maintenance-error.client';
export * from './maintenance-status.client';
import { MaintenanceStatusClient } from './maintenance-status.client';
export * from './maintenance-type.client';
import { MaintenanceTypeClient } from './maintenance-type.client';
export * from './manufacturer.client';
import { ManufacturerClient } from './manufacturer.client';
export * from './manufacturer-dictionary.client';
import { ManufacturerDictionaryClient } from './manufacturer-dictionary.client';
export * from './place.client';
import { PlaceClient } from './place.client';
export * from './pool.client';
import { PoolClient } from './pool.client';
export * from './pool-dictionary.client';
import { PoolDictionaryClient } from './pool-dictionary.client';
export * from './rack.client';
import { RackClient } from './rack.client';
export * from './scans.client';
import { ScansClient } from './scans.client';
export * from './service-center.client';
import { ServiceCenterClient } from './service-center.client';
export * from './service-center-dictionary.client';
import { ServiceCenterDictionaryClient } from './service-center-dictionary.client';
export * from './shelf.client';
import { ShelfClient } from './shelf.client';
export * from './socket-type.client';
import { SocketTypeClient } from './socket-type.client';
export * from './user.client';
import { UserClient } from './user.client';
export * from './warranty-type.client';
import { WarrantyTypeClient } from './warranty-type.client';
export * from './worker.client';
import { WorkerClient } from './worker.client';
export * from './worker-dictionary.client';
import { WorkerDictionaryClient } from './worker-dictionary.client';
export * from './worker-status.client';
import { WorkerStatusClient } from './worker-status.client';
export const APIS = [AgentClient, AgentStatusClient, AuditClient, ClientDictionaryClient, CoinClient, ContainerClient, ContainerDictionaryClient, DashboardClient, EquipmentClient, EquipmentEventCategoryClient, EquipmentEventHistoryClient, EquipmentIdentifierClient, EquipmentModeClient, EquipmentModelClient, EquipmentModelDictionaryClient, EquipmentScheduleClient, EquipmentScheduleAssignmentClient, EquipmentStatusClient, FacilityClient, FacilityDictionaryClient, FirmwareClient, HashrateUnitClient, MaintenanceClient, MaintenanceErrorClient, MaintenanceStatusClient, MaintenanceTypeClient, ManufacturerClient, ManufacturerDictionaryClient, PlaceClient, PoolClient, PoolDictionaryClient, RackClient, ScansClient, ServiceCenterClient, ServiceCenterDictionaryClient, ShelfClient, SocketTypeClient, UserClient, WarrantyTypeClient, WorkerClient, WorkerDictionaryClient, WorkerStatusClient];
